import { Injectable } from "@angular/core";
import { API_URL } from '../constants';
import { BaseDataService, DataService } from "../core/services";

@Injectable()
export class ReportTypeScheduleService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getAll() {
        return super.getAll<any>("ReportTypeSchulde");
    }

    public saveSchedule(model: any) {
        return this.save<any>("ReportTypeSchulde", model);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/report-type-shedule.service.ts